/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 公共组件 =》 预览信息项组件 入口js
 */
import {Toast} from "vant";
export default {
    name: 'cc-preview-item',
    // 混入
    mixins: [],
    // 依赖组件
    components: {},
    // 参数
    props: {
        data: Array
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-cc-preview-item'
            },
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        }
    },
    // 监听
    watch: {},
    // 创建完成
    created() {
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 点击显示对应的数据
         * */
        toast(value){
            // value有值才弹层
            value && Toast(value);
        }
    }
};
